import React from "react";
import { Button, Card, DatePicker, Space } from "antd";

const cardStyle = {
  overflow: "hidden",
  borderRadius: 14,
  border: "1px solid #f0f0f0",
  boxShadow: "0 10px 24px rgba(17, 48, 97, 0.08)",
};

const controlStyle = {
  height: 38,
  borderRadius: 10,
  borderColor: "#d1d5db",
};

const buttonStyle = {
  ...controlStyle,
  paddingInline: 16,
  fontWeight: 400,
};

export default function FiltrosComplementos({
  fecha,
  loading,
  loadingXls,
  onFechaChange,
  onActualizar,
  onVerTodos,
  onDescargarXls,
}) {
  return (
    <Card size="small" style={cardStyle}>
      <Space size={10} wrap>
        <DatePicker
          picker="year"
          format="YYYY"
          value={fecha}
          allowClear={false}
          style={controlStyle}
          onChange={onFechaChange}
        />
        <Button
          loading={loading}
          style={buttonStyle}
          onClick={onActualizar}
        >
          Actualizar
        </Button>
        <Button 
          loading={loading} 
          style={buttonStyle} 
          onClick={onVerTodos}
        >
          Ver todos
        </Button>
        <Button
          loading={loadingXls}
          style={buttonStyle}
          onClick={onDescargarXls}
        >
          Descargar XLS
        </Button>
      </Space>
    </Card>
  );
}
